import { Guest } from './Guest'

export class Booking {
  HotelId = '';
  PMSBookingNumber?: string;
  ReservationNumber?: string;
  Guests: Guest[] = [];
}
